export default "__VITE_ASSET__ChHdO_QT__"